var _isServer = typeof window === 'undefined';

export function isServer() {
  return _isServer;
}
export function setServer(value) {
  _isServer = value;
}
export { isServer as isSSR, setServer as setSSR };